// src/components/AlertDisplay/AlertDisplay.jsx
import React, { useState, useEffect } from 'react';
import './AlertDisplay.css';

// URL base de la API
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://riasbaixaspd.es/api';

const AlertDisplay = ({ page = 'all' }) => {
  const [alerts, setAlerts] = useState([]);
  const [dismissedAlerts, setDismissedAlerts] = useState(() => {
    const stored = localStorage.getItem('dismissedAlerts');
    return stored ? JSON.parse(stored) : [];
  });

  useEffect(() => {
    // Cargar alertas inmediatamente al entrar
    fetchActiveAlerts();
    // Actualizar cada 30 segundos para mostrar cambios rápidamente
    const interval = setInterval(fetchActiveAlerts, 30 * 1000);
    return () => clearInterval(interval);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchActiveAlerts = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/alerts/active`);
      if (response.ok) {
        const data = await response.json();
        // Filtrar por página si es necesario
        const filteredAlerts = data.filter(alert => 
          alert.show_on_pages === 'all' || alert.show_on_pages === page
        );
        setAlerts(filteredAlerts);
      }
    } catch (err) {
      console.error('Error fetching alerts:', err);
    }
  };

  const dismissAlert = (alertId, isFixed) => {
    // Si es una alerta fija, no se puede descartar
    if (isFixed) return;
    
    const newDismissedAlerts = [...dismissedAlerts, alertId];
    setDismissedAlerts(newDismissedAlerts);
    localStorage.setItem('dismissedAlerts', JSON.stringify(newDismissedAlerts));
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'warning': return '⚠️';
      case 'error': return '❌';
      case 'success': return '✅';
      case 'info': return 'ℹ️';
      default: return 'ℹ️';
    }
  };

  // Filtrar alertas no descartadas (excepto las fijas)
  const visibleAlerts = alerts.filter(alert => 
    alert.isFixed || !dismissedAlerts.includes(alert.id)
  );

  // Agrupar alertas por posición
  const alertsByPosition = visibleAlerts.reduce((acc, alert) => {
    const position = alert.position || 'top-center';
    if (!acc[position]) acc[position] = [];
    acc[position].push(alert);
    return acc;
  }, {});

  if (visibleAlerts.length === 0) {
    return null;
  }

  return (
    <>
      {Object.entries(alertsByPosition).map(([position, positionAlerts]) => (
        <div key={position} className={`alert-display-container alert-display-${position}`}>
          {positionAlerts.map(alert => (
            <div key={alert.id} className={`alert-display alert-display-${alert.type} ${alert.isFixed ? 'alert-fixed' : ''}`}>
              <div className="alert-display-icon">
                {getTypeIcon(alert.type)}
              </div>
              <div className="alert-display-content">
                <h4>{alert.title}</h4>
                <p>{alert.message}</p>
              </div>
              {!alert.isFixed && (
                <button 
                  className="alert-display-dismiss"
                  onClick={() => dismissAlert(alert.id, alert.isFixed)}
                  title="Cerrar"
                >
                  ×
                </button>
              )}
            </div>
          ))}
        </div>
      ))}
    </>
  );
};

export default AlertDisplay;